import { updatePricingHolidayRequest } from "../../data/pricingHolidayApi";
import { validatePricingHolidayPayload } from "../validator/validatePricingHolidayPayload";

export async function updatePricingHolidayUseCase(payload) {
  if (!payload?.id) {
    throw new Error("El id es obligatorio.");
  }

  const error = validatePricingHolidayPayload(payload);

  if (error) {
    throw new Error(error);
  }

  return await updatePricingHolidayRequest(payload);
}
